import React, { ReactNode } from "react";
import { Box, Grid, GridSize } from "@material-ui/core";
import { useTranslation } from "react-i18next";

interface ItemProps {
    xs?: boolean | GridSize;
    md?: boolean | GridSize;
    name: string;
    value: string | ReactNode;
}

const Item: React.FC<ItemProps> = ({ xs = 12, md = 6, name, value }) => {
    const [t] = useTranslation();

    return (
        <Grid item xs={xs} md={md}>
            <Box>
                <b>{t(name)}:</b>{' '}
                {typeof value === 'string' ? t(value) : value}
            </Box>
        </Grid>
    );
};

export default Item;
